export default "__VITE_ASSET__DkvDbFOM__"